import axios from 'axios'
import Buefy from 'buefy'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import VueMq from 'vue-mq'
import VeeValidate from 'vee-validate'
import Widgetapp from './Widgetapp'
import router from './widgetrouter'
import 'animate.css/animate.min.css'

Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.use(Buefy)
Vue.use(VueMq, {
  breakpoints: {
    mobile: 1024,
    desktop: Infinity
  }
})
Vue.use(VeeValidate, { inject: false })

/* eslint-disable no-new */
new Vue({
  el: '#widgetapp',
  router,
  components: { Widgetapp },
  template: '<widgetapp/>'
})



// WEBPACK FOOTER //
// ./src/widget.js